<div class="radio__group">
  <p class="title">
    {{ radioTextTitle }} <mat-label class="mandatory">*</mat-label>

    <button 
      type="button"
      *ngIf="helpText"
      mat-icon-button matTooltip="{{helpText}}"
      matTooltipPosition="right"
    >
      <mat-icon class="help-icon">help_outline</mat-icon>
    </button>
  </p>

  <mat-radio-group
    [formControl]="radio"
    (change)="radioSelected()"
    [disabled]="disable"
  >
    <mat-radio-button [id]="idButtonTrue" value="true">Sim</mat-radio-button>
    <mat-radio-button [id]="idButtonFalse" value="false">Não</mat-radio-button>
  </mat-radio-group>
</div>
